/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import API from "../../utils/API";
import Html from "../../utils/Html";
import RelateFilter from "../Org/top.content.relate.filter";
import FilterOrganization from "../Org/top.content.filter.organization";

export default function TopContent({ defaultFilters, key_form }) {
  let filters = defaultFilters;
  filters["key_form"] = key_form;
  filters["organization"] =
    "organization" in defaultFilters ? defaultFilters["organization"] : [];
  //const [orgFilters, setOrgFilters] = useState({data: filters["organization"], key_form: key_form});
  const [relateFilters, setRelateFilters] = useState({
    data: filters["organization"],
    key_form: key_form });
  const [filterData, setFilterData] = useState({
    data: "",
    err: 0,
    err_msg: "",
    status: "" });
  useEffect(() => {
    //console.log("Effect => TopContent");
    const mainFunc = async () =>
      await API.post("org/filter", {
        params: ({
          filters: filters }) });
    mainFunc()
      .then((res) => {
        const decrypt = (res?.data);
        // console.log("response=", decrypt);
        if (decrypt?.status === "success") {
          setFilterData(decrypt);
        } else {
          setFilterData({
            err: 1,
            err_msg: `Failes : ` + decrypt?.err_msg ?? "" });
        }
      })
      .catch((err) => {
        setFilterData({ err: 1, err_msg: `Failes : ${err}` });
      });
  }, [filters]);

  if (filterData?.err === 1) {
    return <div>Fetch request error: {filterData.err_msg}</div>;
  } else if (filterData?.data === "") {
    return (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto" } }}
        />
      </div>
    );
  }
  //console.log("TopContent", filterData["data"], filters);
  if (defaultFilters["organization"].length > 0) {
    let orgData = filterData["data"]["organizations"];
    let tmpOrgs = [];
    for (let i in orgData) {
      if (
        defaultFilters["organization"].indexOf(String(orgData[i]["id"])) > -1
      ) {
        tmpOrgs.push(orgData[i]);
      }
    }
    filterData["data"]["organizations"] = tmpOrgs;
  }
  return (
    <div id="top-content">
      <form
        key={"form-filter-request" + filters.key_form}
        id="form-filter-request"
        method="post"
      >
        <div className="filter-inputs row" id="filter-inputs-orgunit">
          <FilterOrganization
            data={filterData["data"]["organizations"]}
            filters={{
              data: filters["organization"],
              key_form: filters["key_form"] }}
          />
          {/* <RelateFilter filters={relateFilters} data={filterData} /> */}
          <RelateFilter
            filters={relateFilters}
            filterData={filterData}
            setFilterData={setFilterData}
          />
        </div>
      </form>
    </div>
  );
}

const Feature = {};


